export default __webpack_public_path__ + "static/alberio-bathory-frota-413ced348d6ff584486210202539b834.png";